<h2 mat-dialog-title>Print Stickers - {{data.product_title}}</h2>

<mat-dialog-content class="dialog-stickers-content" style="padding-top: 15px !important; min-height: 50vh;">
    <!-- Loading State -->
    <div *ngIf="loading" class="spinner-container"
        style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px 0;">
        <mat-spinner diameter="50"></mat-spinner>
        <p style="margin-top: 15px; color: #4a5568;">Pre-generating QR code templates...</p>
    </div>

    <!-- Controls Panel -->
    <div *ngIf="!loading" class="print-controls"
        style="display: flex; gap: 16px; margin-bottom: 20px; align-items: center; background: #f7fafc; padding: 15px; border-radius: 8px; border: 1px solid #edf2f7; flex-wrap: wrap;">
        <mat-form-field appearance="outline" style="flex: 1; min-width: 200px; max-width: 260px;"
            subscriptSizing="dynamic">
            <mat-label>Sticker Layout</mat-label>
            <mat-select [(ngModel)]="layout">
                <mat-option value="10x14">10x14 Grid (140 stickers/page)</mat-option>
                <mat-option value="5x10">5x10 Grid (50 stickers/page)</mat-option>
                <mat-option value="3x8">3x8 Grid (24 stickers/page)</mat-option>
                <mat-option value="2x5">2x5 Grid (10 stickers/page)</mat-option>
                <mat-option value="single">Single Label (Roll)</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="flex: 1; min-width: 130px; max-width: 180px;"
            subscriptSizing="dynamic">
            <mat-label>Start Offset (Skip slots)</mat-label>
            <input matInput type="number" [(ngModel)]="offset" min="0" max="23">
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="generatePDF()"
            style="height: 48px; display: inline-flex; align-items: center; gap: 8px;">
            <mat-icon>picture_as_pdf</mat-icon> Generate PDF
        </button>
    </div>

    <!-- Preview Grid -->
    <div *ngIf="!loading" class="stickers-preview-wrapper"
        style="border: 1px dashed #cbd5e0; padding: 20px; background: #e2e8f0; border-radius: 10px; overflow-y: auto; max-height: 50vh;">
        <div [class]="'preview-grid layout-' + layout" [style.display]="'grid'"
            [style.grid-template-columns]="layout === '10x14' ? 'repeat(10, 1fr)' : (layout === '5x10' ? 'repeat(5, 1fr)' : (layout === '3x8' ? 'repeat(3, 1fr)' : (layout === '2x5' ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)')))"
            [style.gap]="layout === '10x14' ? '4px' : '12px'" [style.background]="'white'" [style.padding]="'20px'"
            [style.box-shadow]="'0 4px 10px rgba(0,0,0,0.05)'" [style.border-radius]="'8px'">
            <div *ngFor="let slot of getPreviewSlots()" [class.empty-sticker]="slot.isEmpty"
                [class.sticker-card]="!slot.isEmpty"
                [style.border]="slot.isEmpty ? '1px dashed #cbd5e0' : '1px dotted #a0aec0'"
                [style.border-radius]="'6px'" [style.padding]="'12px'" [style.display]="'flex'"
                [style.flex-direction]="'column'" [style.align-items]="'center'" [style.justify-content]="'center'"
                [style.min-height]="layout === '10x14' ? '60px' : (layout === '5x10' ? '80px' : (layout === '3x8' ? '120px' : (layout === '2x5' ? '180px' : '100px')))"
                [style.background]="slot.isEmpty ? '#f7fafc' : '#ffffff'">

                <!-- Blank Slot -->
                <span *ngIf="slot.isEmpty"
                    style="font-size: 10px; color: #a0aec0; text-transform: uppercase; font-weight: 500;">Skipped
                    Slot</span>

                <!-- Printable Sticker Content -->
                <div *ngIf="!slot.isEmpty"
                    style="display: flex; flex-direction: column; align-items: center; text-align: center; width: 100%;">
                    <!-- <span class="sticker-company" style="font-size: 9px; font-weight: 600; text-transform: uppercase; color: #4a5568; letter-spacing: 0.5px; margin-bottom: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;">{{data.company_name}}</span> -->
                    <span class="sticker-product"
                        style="font-size: 11px; font-weight: 700; color: #1a202c; margin-bottom: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;">{{slot.serial_number}}</span>

                    <img [src]="slot.qrDataUrl" style="width: 70px; height: 70px; object-fit: contain; margin: 4px 0;"
                        alt="QR Code">

                    <span class="sticker-cta"
                        style="font-size: 8px; font-weight: 500; color: #718096; text-transform: uppercase; letter-spacing: 0.3px; margin-top: 2px;">Scan
                        to claim points!</span>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>